import request from '../index';

// 获取公开分类列表（不需要登录）
export const getPublicCategories = () => {
  return request.get('/merchant-categories/public');
};

// 获取所有分类
export const getCategories = (includeInactive = false) => {
  return request.get('/merchant-categories', {
    params: { includeInactive }
  });
};

// 获取分类统计
export const getCategoryStats = () => {
  return request.get('/merchant-categories/stats');
};

// 获取单个分类
export const getCategory = (id) => {
  return request.get(`/merchant-categories/${id}`);
};

// 创建分类
export const createCategory = (data) => {
  return request.post('/merchant-categories', data);
};

// 更新分类
export const updateCategory = (id, data) => {
  return request.put(`/merchant-categories/${id}`, data);
};

// 删除分类
export const deleteCategory = (id) => {
  return request.delete(`/merchant-categories/${id}`);
};

// 切换分类状态
export const toggleCategoryStatus = (id) => {
  return request.put(`/merchant-categories/${id}/toggle`);
};

export default {
  getPublicCategories,
  getCategories,
  getCategoryStats,
  getCategory,
  createCategory,
  updateCategory,
  deleteCategory,
  toggleCategoryStatus,
};
